/*
 * "1 peça de brinde" (BOGOS) — aniversário Murano campaign discount bridge.
 * INDEPENDENT of bogos-cart-sync.js and bogos-letter-necklace-gift.js. Do not
 * merge with either.
 * ------------------------------------------------------------------
 * WHY THIS EXISTS: same root cause as the other two BOGOS bridges — its gift
 * engine only activates on cart UIs it recognizes and stays inert on this
 * theme's native cart, so this offer's own condition (10+ items -> cheapest
 * item free) never gets checked or applied here.
 *
 * WHY THE FIX IS DIFFERENT FROM THE OTHER TWO: this offer is not a cloned
 * gift product — decoded from BOGOS's own data bundle (freegifts_data_*.min.js,
 * the packed `window.fgData=...` assignment) as a `type: "cheapest"` discount
 * entry: 100% off the single cheapest cart line once quantity >= 10, gated to
 * visitors who arrived via a link carrying `?discounts_code=aniversario-murano`
 * (BOGOS's own sub_conditions.specific_link_address), applying BOGOS's own
 * Shopify discount code "BOGOS-Cafj03" (shopify_discount_id 1873417011454).
 *
 * That code is a REAL Shopify discount with its own minimum-quantity
 * condition already enforced server-side — confirmed live: applying it to a
 * cart with only 2 qualifying items produces zero discount, and once applied
 * it stays dormant until the cart genuinely reaches 10, at which point
 * Shopify itself splits the cheapest line and zeroes it out. So the only
 * missing piece is telling Shopify this visitor has the code at all — no
 * threshold counting, no picker UI, no cart-mutation watching needed here.
 *
 * 2026-08-21 fix: applying the code alone isn't enough when the cart ALREADY
 * has 10+ qualifying items by the time this script runs (e.g. the visitor was
 * already shopping, then landed on the campaign link on a later pageview).
 * The server-side cart (/cart.js) reflects the discount immediately, but the
 * drawer/cart page's already-rendered HTML doesn't — opening the drawer just
 * toggles visibility of whatever was server-rendered at page load
 * (assets/cart.js `open()` never refetches), so the free item stayed
 * invisible until some unrelated mutation (e.g. remove-then-re-add) forced a
 * section refresh. Fixed by dispatching `cart:refresh` right after applying
 * the code, so an already-qualifying cart re-renders immediately.
 *
 * If this offer's code or link param is ever changed in the BOGOS app, redo
 * the packed-bundle decode described in the "BOGOS free-gift integration"
 * memory to find the new values.
 */
(function () {
  if (window.__bogosAniversarioGiftInstalled) return;
  window.__bogosAniversarioGiftInstalled = true;

  var LINK_PARAM = "discounts_code";
  var LINK_VALUE = "aniversario-murano";
  var DISCOUNT_CODE = "BOGOS-Cafj03";
  var ELIGIBLE_KEY = "bogosAniversarioMuranoEligible";
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function isEligible() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get(LINK_PARAM) === LINK_VALUE) {
        localStorage.setItem(ELIGIBLE_KEY, "1");
        return true;
      }
      return localStorage.getItem(ELIGIBLE_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  if (!isEligible()) return;

  fetch(ROOT.replace(/\/$/, "") + "/discount/" + DISCOUNT_CODE, { credentials: "same-origin" })
    .then(function () {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    })
    .catch(function () {});
})();
